import React, { useState } from "react";
import {
Menu,
X,
} from "lucide-react";

import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";

const navLinks = [
{ label: "Home", href: "/" },
{ label: "About", href: "/about" },
{ label: "Solutions", href: "/solutions" },
{ label: "Services", href: "/services" },
{ label: "Projects", href: "/projects" },
{ label: "Blogs", href: "/blogs" },
{ label: "Contact", href: "/contact" },
];

function Header() {
const [mobileOpen, setMobileOpen] = useState(false);

return (
<> <header className="modern-navbar">
{/* LOGO */} <a href="/" className="navbar-logo"> <img
         src="images/LandingPage/logo.png"
         alt="Logo"
       /> </a>


    {/* DESKTOP MENU */}
    <nav className={mobileOpen ? "nav-links open" : "nav-links"}>
      {navLinks.map((item) => (
        <a
          key={item.label}
          href={item.href}
          onClick={() => setMobileOpen(false)}
        >
          {item.label}
        </a>
      ))}
    </nav>

    {/* RIGHT SECTION */}
    <div className="navbar-right">
      {/* SOCIALS */}
     

      {/* CTA BUTTON */}
      <a
        href="/contact"
        className="navbar-btn"
      >
        Get Started
      </a>

      {/* MOBILE BUTTON */}
      <button
        className="mobile-menu-btn"
        onClick={() => setMobileOpen(!mobileOpen)}
      >
        {mobileOpen ? <X size={22} /> : <Menu size={22} />}
      </button>
    </div>
  </header>

  {/* CSS */}
  <style>{`

    .modern-navbar{
      position: fixed;
      top: 14px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 40px);
      max-width: 1250px;
      height: 78px;
      padding: 0 24px;

      display: flex;
      align-items: center;
      justify-content: space-between;

      background: #fff;
      backdrop-filter: blur(18px);

      border: 1px solid rgba(255,255,255,0.4);

      border-radius: 24px;

      box-shadow:
        0 10px 40px rgba(0,0,0,0.08);

      z-index: 9999;
    }

    .navbar-logo img{
      height: 38px;
      width: auto;
      object-fit: contain;
    }

    .nav-links{
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .nav-links a{
      text-decoration: none;
      color: #0f172a;
      font-size: 14px;
      font-weight: 600;

      padding: 10px 14px;
      border-radius: 12px;

      transition: 0.3s;
    }

    .nav-links a:hover{
      background: rgba(0,120,201,0.08);
      color: #0078c9;
    }

    .navbar-right{
      display: flex;
      align-items: center;
      gap: 14px;
    }

    .social-icons{
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .social-icons a{
      width: 36px;
      height: 36px;

      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: 50%;

      background: rgba(0,120,201,0.08);

      color: #0078c9;

      transition: 0.3s;
    }

    .social-icons a:hover{
      background: #9e0b22;
      color: white;
      transform: translateY(-2px);
    }

    .navbar-btn{
      text-decoration: none;

      background: linear-gradient(
        135deg,
        #0078c9,
        #005b98
      );

      color: white;

      padding: 12px 22px;

      border-radius: 999px;

      font-size: 14px;
      font-weight: 700;

      transition: 0.3s;

      box-shadow:
        0 8px 24px rgba(0,120,201,0.28);
    }

    .navbar-btn:hover{
      transform: translateY(-2px);
      box-shadow:
        0 12px 28px rgba(0,120,201,0.38);
    }

    .mobile-menu-btn{
      display: none;

      border: none;
      outline: none;

      background: rgba(0,120,201,0.08);

      color: #0078c9;

      width: 42px;
      height: 42px;

      border-radius: 12px;

      cursor: pointer;
    }

    @media(max-width: 1024px){

      .social-icons{
        display: none;
      }

      .mobile-menu-btn{
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .nav-links{
        position: absolute;

        top: 92px;
        left: 0;
        right: 0;

        margin: auto;

        width: calc(100% - 20px);

        background: white;

        border-radius: 24px;

        padding: 18px;

        display: none;
        flex-direction: column;

        box-shadow:
          0 18px 50px rgba(0,0,0,0.08);
      }

      .nav-links.open{
        display: flex;
      }

      .nav-links a{
        width: 100%;
      }

    }

    @media(max-width: 640px){

      .modern-navbar{
        padding: 0 16px;
        height: 72px;
      }

      .navbar-logo img{
        height: 50px;
      }

      .navbar-btn{
        display: none;
      }

    }

  `}</style>
</>


);
}

export default Header;
